import {TKey} from '@/translations/i18n'
import {ExternalCostCode} from './types'

export const currentYear = new Date().getFullYear()

export const yearsOptions = (() => {
    const endYear = currentYear + 2

    return Array.from({length: endYear - 2025 + 1}, (_, i) => `${2025 + i}`)
})()

export const externalCodeToLabel = {
    AA1: 'budget:access_rate_code_aa1',
    AA2: 'budget:access_rate_code_aa2',
    AM: 'budget:access_rate_code_am',
    D1: 'budget:access_rate_code_d1',
    D2: 'budget:access_rate_code_d2'
} as const satisfies Record<ExternalCostCode, TKey>
